// @flow

import * as React from 'react';
import parseEmoji from 'app/lib/parseEmoji';
import { shortMessage } from "app/lib/commits";

type Props = {
  message: ?string
};

export default class BuildMessage extends React.PureComponent<Props> {
  render() {
    if (!this.props.message) {
      return (
        <span
          aria-label="This will be replaced by the commit message once the build starts"
          data-tooltip-length="medium"
          className="dark-gray"
          style={{
            fontWeight: "normal"
          }}
        >
          …
        </span>
      );
    }

    const firstLine = shortMessage(this.props.message);
    const messageWithEmoji = parseEmoji(firstLine);

    return (
      <span
        title={this.props.message}
        dangerouslySetInnerHTML={{
          __html: messageWithEmoji
        }}
      />
    );
  }
}
